import { CustomButton } from 'components/ui'
import Modal from 'components/ui/Modal/Modal'
import {
  useUpdateActividad,
  useDeleteActividad,
  useActividadDependencies,
} from 'lib/react-query/queriesActividad'
import { Tooltip } from 'react-tooltip'
import React from 'react'
import ModalWithStates from '../Articulos/FormNewArticulo/ModalWithStates'

const ModalDeleteActividadAdmin = ({ handleOnClose, actividad }) => {
  // const { mutateAsync: updateArticulo } = useUpdateSingleArticulo()
  const { mutateAsync: updateActividad } = useUpdateActividad()
  const { mutateAsync: deleteActividad } = useDeleteActividad()
  const {
    data: dependencies,
    isLoading,
    isError,
  } = useActividadDependencies(actividad._id)

  const hasBimlink = dependencies?.hasBimlink
  const hasBoq = dependencies?.hasBoq
  const bimlinkCodes = dependencies?.bimlinkCodes || []
  const hasDependencies = hasBimlink || hasBoq

  const handleOnClick = () => {
    updateActividad({ id: actividad._id, active: false })
    handleOnClose()
  }

  const handleOnDelete = async () => {
    try {
      await deleteActividad(actividad._id)
      handleOnClose()
    } catch (error) {
      console.error('Error al eliminar artículo:', error)
    }
  }

  return (
    <ModalWithStates
      isLoading={isLoading}
      isError={isError}
      dependencies={dependencies}
      onClose={handleOnClose}
    >
      <div className="modal-link-bimlink-to-tipo-container--width">
        <h2>{`Eliminar ${actividad.name}`}</h2>

        {!hasDependencies && (
          <p className="modal-link-bimlink-question">
            ¿Estás seguro de que desea eliminar esta actividad? Una vez
            eliminada, no podrás recuperarla.
          </p>
        )}

        {hasBimlink && (
          <div className="modal-link-bimlink-box">
            {hasBoq && (
              <p className="modal-link-bimlink-question">
                No puedes eliminar la actividad si pertenece a un BOQ.
              </p>
            )}
            <p className="modal-link-bimlink-question">
              No puedes eliminar la actividad si pertenece a algún BimLink:
            </p>
            <ul className="modal-link-bimlink-list">
              {bimlinkCodes?.slice(0, 5).map(code => (
                <li key={code}>{code}</li>
              ))}
              {bimlinkCodes?.length > 5 && <li>...</li>}
            </ul>
          </div>
        )}

        {hasDependencies && (
          <p>
            Puedes deshabilitar la actividad para que no aparezca al enlazar en
            ninguna BimLink
          </p>
        )}

        <div className="buttons-container-edit-form buttons-container-delete-articulo">
          <CustomButton
            type="secondary"
            onClick={handleOnClose}
            className="button-delete-articulo"
          >
            Cancelar
          </CustomButton>

          {hasDependencies && (
            <CustomButton
              type="submit"
              className="button-delete-articulo"
              onClick={handleOnClick}
            >
              Deshabilitar
            </CustomButton>
          )}

          <CustomButton
            type="submit"
            className="button-delete-articulo button-tooltip-delete"
            onClick={handleOnDelete}
            disabled={hasDependencies}
          >
            Eliminar
          </CustomButton>

          <Tooltip
            anchorSelect=".button-tooltip-delete"
            style={{
              fontSize: '10px',
              display: hasDependencies ? 'block' : 'none',
            }}
          >
            No puedes eliminar esta actividad porque tiene dependencias.
          </Tooltip>
        </div>
      </div>
    </ModalWithStates>
  )
}

export default ModalDeleteActividadAdmin
